
export default {
  root: {
    fontSize: '1.5rem'
  }
}
